/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
import { useState } from 'react';

const useSearch = () => {
  const initSearchFilters = {
    campaignDate: new Date(),
  };
  const initSearchDataGrid = {
    sort: [],
    filters: {
      items: [],
      quickFilterValues: [],
    },
  };
  const [searchChannels, setSearchChannels] = useState();
  const [searchFilters, setSearchFilters] = useState(initSearchFilters);
  const [searchDataGrid, setSearchDataGrid] = useState(initSearchDataGrid);

  const updateFilters = (key, value) => {
    const filter = {
      ...searchFilters,
      [key]: value,
    };
    setSearchFilters(filter);
  };

  const updateDataGrid = (key, values) => {
    const dataGrid = {
      ...searchDataGrid,
      [key]: values,
    };
    setSearchDataGrid(dataGrid);
  };

  const cleanSearchDataGrid = () => {
    setSearchFilters(initSearchFilters);
    setSearchDataGrid(initSearchDataGrid);
  };

  return {
    searchChannels,
    setSearchChannels,
    searchFilters,
    updateFilters,
    searchDataGrid,
    updateDataGrid,
    cleanSearchDataGrid,
  };
};

export default useSearch;
